module.exports = __webpack_public_path__ + "static/media/Santai_Ngobrolin_Buku_PNG-02.665bd099.png";